export const FONTS = [
  "Alex Brush", "Great Vibes", "Allura", "Dancing Script", "Pacifico", "Sacramento", "Parisienne", "Satisfy", "Kaushan Script", "Tangerine",
  "Pinyon Script", "Italianno", "Marck Script", "Courgette", "Caveat", "Kalam", "Lobster", "Petit Formal Script", "Herr Von Muellerhoff", "Mr Dafoe",
  "Monsieur La Doulaise", "Euphoria Script", "Arizonia", "Ms Madi", "Imperial Script", "Birthstone", "Corinthia", "Ephesis", "Water Brush", "Mea Culpa",
  "Lavishly Yours", "Ballet", "Comforter Brush", "Qwigley", "Cinzel", "Cinzel Decorative", "Playfair Display", "Cormorant Garamond", "Bodoni Moda", "DM Serif Display",
  "Abril Fatface", "Marcellus", "Yeseva One", "Lora", "Montserrat", "Plus Jakarta Sans", "Outfit", "Raleway", "Josefin Sans", "Bebas Neue",
];

const fam = (n) => `family=${n.replace(/ /g, "+")}`;

export function loadFonts(names, id) {
  const list = names.filter(Boolean);
  if (!list.length || document.getElementById(id)) return;
  const l = document.createElement("link");
  l.id = id;
  l.rel = "stylesheet";
  l.href = `https://fonts.googleapis.com/css2?${list.map(fam).join("&")}&display=swap`;
  document.head.appendChild(l);
}

export const fontStack = (n) => (n ? `'${n}', cursive` : undefined);
